(function () {
  'use strict';

  angular
    .module('app.comparator', [])

    /* @ngInject */
    .component('comparator', {
      templateUrl: '/Template/Comparator/Comparator',
      /* @ngInject */
      controller: ["$rootScope", "$timeout", "$location", "$element", "CompareService", "$uibPosition", function ($rootScope, $timeout, $location, $element, CompareService, $uibPosition) {
        var ctrl = this,
          unwatch;

        $timeout(function () {
          ctrl.count = CompareService.getNbProducts();
          if (typeof $location.search().open !== 'undefined') {
            toggle();
          }
        }, 3000);

        ctrl.$onDestroy = function () {
          if (unwatch !== null) {
            unwatch();
          }
        };

        unwatch = $rootScope.$on('comparatorCheckboxUpdate', function () {
          ctrl.count = CompareService.getNbProducts();
        });

        ctrl.empty = function (event) {
          event.stopPropagation();
          if (ctrl.opened) {
            toggle();
          }
          CompareService.empty();
          updateProductsData();
          $rootScope.$broadcast('comparatorUpdate');
        };

        ctrl.remove = function (id) {
          CompareService.remove(id);
          updateProductsData();
        };

        ctrl.toggle = function () {
          if (ctrl.count < 2) return;
          toggle();
        };

        // Functions

        function updateProductsData() {
          ctrl.properties = {};
          ctrl.products = [];
          ctrl.resized = false;

          var products = CompareService.get(),
            len = products.length,
            i;

          ctrl.showLoader = true;
          ctrl.count = len;
          ctrl.tmpProducts = [];
          for (i = 0; i < len; i++) {
            CompareService.getProduct(products[i])
              .then(function (data) {
                ctrl.tmpProducts.push(data);
                if (ctrl.tmpProducts.length === ctrl.count) {
                  setProperties();
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        }

        function setProperties() {
          var len1 = ctrl.tmpProducts.length,
            len2,
            i, j, k;

          var tmp = {};
          for (i = 0; i < len1; i++) {
            var props = ctrl.tmpProducts[i].Properties;
            len2 = props.length;
            for (j = 0; j < len2; j++) {
              var prop = props[j];
              if (prop.IsInTable) {
                if (!tmp[prop.Designation]) {
                  tmp[prop.Designation] = [];
                  for (k = 0; k < len1; k++) {
                    tmp[prop.Designation][k] = '';
                  }
                }
                tmp[prop.Designation][i] = prop.TextValue;
              }
            }
          }
          ctrl.properties = tmp;
          ctrl.products = ctrl.tmpProducts;
          if (ctrl.opened) {
            if (ctrl.count < 2) {
              toggle();
            } else {
              $timeout(resizeProducts);
            }
          }

          $rootScope.$broadcast('comparatorUpdate');
        }

        function resizeProducts() {
          var wLegend  = 300;
          var wItem  = 0;

          $element.find('table').css('width', '').find('.value').css('width', '');

          if ((ctrl.count * 400 + wLegend) < $(window).width()) {
            wItem = Math.floor(($(window).width() - wLegend) / ctrl.count);
            $element.find('table').find('.value').width(wItem);
          } else {
            $element.find('table').width(ctrl.count * 400 + wLegend);
          }

          $element.find('.product').each(function () {
            $(this).find('.name').equalHeights();
          });

          ctrl.resized = true;
          ctrl.showLoader = false;
          $rootScope.$broadcast('lazyImg:refresh');
        }

        function toggle() {
          ctrl.opened = !ctrl.opened;

          CompareService.toggle(ctrl.opened);

          var $body = $(document.body);
          if (ctrl.opened) {
            var scrollbarPadding = $uibPosition.scrollbarPadding($body.addClass('modal-open'));
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              $body.addClass('modal-open').css({paddingRight: scrollbarPadding.right + 'px'});
            }
            updateProductsData();
          } else {
            $body.removeClass('modal-open').css({paddingRight: '0'});
          }
        }
      }]
    });

})();
